import axios from 'axios';
import { getSecureToken } from '../ApisService/apiService';
import { API_BASE_URL } from '../ApiConfig';
import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';

const AutoLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const email = localStorage.getItem("autoLoginEmail");
    const fullName = localStorage.getItem("fullName");
    const mobileNumber = localStorage.getItem("mobilenumber");

    // Agar koi value missing ho, to auto-login skip karo
    if (!email || !fullName || !mobileNumber) return;

    const doAutoLogin = async () => {
      try {
        const { secrettoken, ts } = await getSecureToken();

        const response = await axios.post(
          `${API_BASE_URL}auth/auto_login.php`,
          {
            email,
            fullName,
            mobileNumber,
          },
          {
            headers: {
              'X-TOKEN': secrettoken,
              'X-TIMESTAMP': ts,
            },
            withCredentials: true,
          }
        );

        if (response.data.status === "success") {
          navigate('/dashboard');
        } else {
          console.warn("Auto-login failed:", response.data.message);
          // Optional: clear localStorage if session invalid
          // localStorage.removeItem("autoLoginEmail");
          // localStorage.removeItem("fullName");
          // localStorage.removeItem("mobilenumber");
        }
      } catch (error) {
        console.error("Auto-login error:", error);
      }
    };

    doAutoLogin();
  }, [navigate]);

  return null;
};

export default AutoLogin;
